import { LegalEntityUpdatePayload, SearchableQueryOptions } from '@mkp/legal-entity/data-access';
import { createActionGroup, props } from '@ngrx/store';

export const claimManagementActions = createActionGroup({
  source: 'Claim Management Page',
  events: {
    Load: props<{ query: SearchableQueryOptions }>(),
    'Load More': props<{ query: SearchableQueryOptions }>(),
    'Select Legal Entity': props<{ legalEntityId: string }>(),
    'Load Account From Selected Legal Entity': props<{ legalEntityId: string }>(),
    'Update Legal Entity Status': props<LegalEntityUpdatePayload>(),
  },
});
